export default "__VITE_ASSET__BaR2BmvW__"